<i18n>
{
  "fr": {
    "error-unauthorized-access-query": "Vous n'avez pas les droits nécessaires pour accéder à cette information.",
    "error-unauthorized-access-mutation": "Vous n'êtes pas autorisé à effectuer cette action."
  },
  "en": {
    "error-unauthorized-access-query": "You do not have access to this information.",
    "error-unauthorized-access-mutation": "You are not authorized to take this action."
  }
}
</i18n>
<template>
  <div>
    <div v-if="showMenu" class="app">
      <div class="mb-24px is-hidden-screen">
        <img :src="require('@/assets/logo-core.svg')" alt="Plateforme Core" />
      </div>
      <div class="app__line"></div>
      <div class="app__nav is-hidden-print">
        <nav-app />
      </div>
      <div class="app__main">
        <breadcrumb class="is-hidden-print mb-24px" />
        <router-view />
      </div>
    </div>
    <router-view v-else />
  </div>
</template>

<script>
import NavApp from '@/components/nav/nav-app'
import Breadcrumb from '@/components/nav/breadcrumb'

export default {
  computed: {
    showMenu: function () {
      if (this.$route.matched.length === 0) return false
      return !this.$route.meta.fullscreen
    }
  },
  components: {
    NavApp,
    Breadcrumb
  },
  methods: {
    bodyClass() {
      document.body.classList.remove('app-body-modifier')
      if (this.showMenu) {
        document.body.classList.add('app-body-modifier')
      }
    }
  },
  watch: {
    showMenu() {
      this.bodyClass()
    }
  },
  mounted() {
    this.bodyClass()
  },
  gqlErrors() {
    return {
      UNAUTHORIZED_ACCESS(error) {
        switch (error.operationType) {
          case 'mutation':
            return this.$t('error-unauthorized-access-mutation')
          default:
            return this.$t('error-unauthorized-access-query')
        }
      }
    }
  }
}
</script>


<style lang="scss">
@import '@/scss/pre-helpers';
@import '~bulma';
@import '~buefy/src/scss/buefy';
@import '@/scss/scaffolding';
@import '@/scss/card';
@import '@/scss/content';
@import '@/scss/tabs';
@import '@/scss/message';
@import '@/scss/helpers';

$app-nav-width: 200px;

@media screen {
  body.app-body-modifier {
    background: $grey-lightest url(~@/assets/layout-background.png) no-repeat 100% calc(100% + 12px);
    background-size: auto 93px;
    min-height: 100vh;
    padding-bottom: 80px;

    @include tablet {
      background-position: calc(100% - 64px) calc(100% + 12px);
    }

    @include desktop {
      background-position: calc(100% - 128px) calc(100% + 12px);
      background-size: auto 140px;
      padding-bottom: 128px;
    }
  }

  .app {
    &__line {
      background-color: $primary;
      height: $space-4px;
      left: 0;
      pointer-events: none;
      position: fixed;
      top: 0;
      width: 100%;
      z-index: 31; // Above nav-bar
    }
    &__main {
      padding: 0 $space-12px $space-24px;
    }
  }

  @include tablet {
    .app {
      &__main {
        padding: 0 $space-32px $space-32px;
      }
    }
  }

  @include desktop {
    .app {
      padding: $space-48px $space-32px;

      &__line {
        height: $space-8px;
      }

      &__nav {
        height: 100%;
        left: 0;
        max-height: 100%;
        overflow: auto;
        padding: $space-32px $space-24px;
        position: fixed;
        top: 0;
        width: $app-nav-width + $space-24px * 2;
      }

      &__main {
        margin-left: $app-nav-width + $space-32px;
        padding: 0;
      }
    }
  }

  @include widescreen {
    .app {
      padding: $space-48px;

      &__nav {
        padding: $space-32px;
        width: $app-nav-width + $space-32px * 2;
      }

      &__main {
        margin-left: $app-nav-width + $space-32px;
        padding: 0;
      }
    }
  }
}
</style>
